import { Operation } from './../model/requests-model';
import { RequestsGetDataApi } from '@app/requests/requests-get-data-service/requests-get-data-api.service';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService, CredentialsService } from '@app/login';
import { OperationHistoricDocumentationDTO, RequestFormDTO } from '../model/requests-model';
import { LoaderGenericService } from '@app/@shared/loader-generic/loader-generic.service';
import { Credentials } from '@app/@core/models/login-models';
import { PanelStore } from '../panel/panel.store';
import { UserAttributionsEnum } from '@app/@core/constants/user-credentials.constants';
import {
  BRAND_AUTOS,
  BRAND_CONSUMO,
  BRAND_MANGO,
  BRAND_MANGONS,
  BRAND_TARJETA,
  FORMALIZADAS_ABONADAS_VALIDADAS,
  PENDIENTES_DE_DATOS,
  REQUEST_MODE_EDIT,
} from '@app/@core/constants/requests.constants';
import { CommonDataDTO } from '../model/combos-model';
import { RequestsGetDataStore } from '../requests-get-data-service/requests-get-data.store';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ResponseDialogComponent } from '@app/@shared/dialogs/response/response-dialog.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-request-show-edit',
  templateUrl: './request-show-edit.component.html',
  styleUrls: ['./request-show-edit.component.scss'],
})
export class RequestShowEditComponent implements OnInit {
  public requestForm: boolean = false;
  public requestAutoForm: boolean = false;
  public requestBPForm: boolean = false;
  public requestMgForm: boolean = false;
  public requestMgNoShopForm: boolean = false;

  public requestData: RequestFormDTO | any;
  public mode: any;
  public state: CommonDataDTO;
  public operative: string;
  public hostStatus: string = '';

  public userInfo: Credentials;
  public listDocumentation: any[];
  public previousUrl: any;

  private isDocumentationLoaded: boolean;
  private isRequestsLoaded: boolean;
  private isRequestsCallLoaded: boolean;

  private brand: string = null;

  public operation: Operation;
  selectedIndex: number = 0;

  constructor(
    private authenticationService: AuthenticationService,
    private credentialsService: CredentialsService,
    public router: Router,
    public route: ActivatedRoute,
    public requestGetApi: RequestsGetDataApi,
    private requestsGetDataStore: RequestsGetDataStore,
    private loaderGenericService: LoaderGenericService,
    private panelStore: PanelStore,
    public dialog: MatDialog,
    public translate: TranslateService
  ) {
    this.userInfo = this.credentialsService.credentials;
  }

  public ngOnInit() {
    this.triggerStopLoader();
    console.log(this.mode);
    this.route.params.subscribe((params) => {
      // console.log('params', params);
      // this.numOperation = params['numOperation'];
      this.mode = params['mode'];
      if (params['tab'] === 'documentation') {
        this.selectedIndex = 1;
      }
      // this.state = params['state'];
      // let captacionCanal = params['captacionCanal']; //AE mango con compra
      // this.brand = params['brand'];

      //recuperamos la operacion del store
      this.operation = this.panelStore.getOperationToShow();
      if (this.operation === undefined) {
        this.router.navigate(['/requests/panel', { keepFilter: true }]);
      } else {
        this.operative = this.operation.operative;
        this.state = this.panelStore.getStatusById(this.operation.status);
        this.hostStatus = this.operation.hostStatus;
        //PARA CARGAR LOS FORMULARIOS TENEMOS QUE DIFERENCIAR POR SUBPRODUCTO, QUE SON LOS DOS PRIMEROS DIGITOS DEL COMMERCIALPRODUCT
        if (this.operation.finacialProduct) {
          console.log(this.operation.finacialProduct);
          switch (this.operation.finacialProduct) {
            case '10':
              this.brand = BRAND_CONSUMO;
              this.requestForm = true;
              break;
            case '20':
              this.brand = BRAND_AUTOS;
              this.requestAutoForm = true;
              break;
            case '30':
              //marca para REPSOL: TARJETA_REPSOL, marca para gasoleo TARJETA_REPSOL_GS, marca para credicuentas TARJETA_CUENTAS_CRED
              if (this.operation.comarca.includes('REPSOL') || this.operation.comarca.includes('CUENTAS')) {
                this.brand = BRAND_CONSUMO;
                this.requestForm = true;
              } else if (this.operation.comarca.includes('TARJETA')) {
                this.brand = BRAND_TARJETA;
                this.requestBPForm = true;
              } else {
                if (this.operation.captacionCanal === 'AE') {
                  this.brand = BRAND_MANGO;
                  this.requestMgForm = true;
                } else {
                  this.brand = BRAND_MANGONS;
                  this.requestMgNoShopForm = true;
                }
              }
              break;
            case '40': //leasing
              this.brand = BRAND_AUTOS;
              this.requestAutoForm = true;
              break;
            case '15': //leasing
              this.brand = BRAND_AUTOS;
              this.requestAutoForm = true;
              break;
            default:
              this.brand = '';
              break;
          }
        }
        this.isRequestsCallLoaded = false;
        this.getRequest(this.brand, this.operation.finacialProduct);

        this.isDocumentationLoaded = false;
        this.getDocumentation();
      }
    });
  }

  getDocumentation() {
    let numOperation: OperationHistoricDocumentationDTO = { numOperation: this.operation.numOperation };
    this.requestGetApi.postDocumentation(numOperation).subscribe(
      (data) => {
        if (data.documentList) {
          this.listDocumentation = data.documentList;
        }
      },
      (error) => {
        console.error(error);
        this.router.navigate(['/error/403'], { replaceUrl: true });
      },
      () => (this.isDocumentationLoaded = true)
    );
  }

  getRequest(brand: string, comercialProduct: string) {
    //llamar al servicio de conseguir los detalles de la solicitud
    let detailRequest = {
      numOperation: this.operation.numOperation,
      commercialProduct: comercialProduct,
      establishment: this.operation.establishment, //this.userInfo.userType === 'V' ? this.userInfo.parentId : this.userInfo.userId
    };
    console.log(detailRequest);

    this.requestGetApi.getDetailRequest(detailRequest, brand).subscribe(
      (data) => {
        this.requestsGetDataStore.setRequestDigitalID(data.digitalId);
        this.requestData = data;
        //Operative is needed for printing authorization
        this.requestData.codeOperative = this.operation.operative;
        console.log('datos solicitud: ', this.requestData);
      },
      (error) => {
        console.error(error);
        this.router.navigate(['/error/403'], { replaceUrl: true });
      },
      () => {
        // ESPSCFWMTS-7415 Controlar navegación a detalle de solicitud
        if (this.state.id === FORMALIZADAS_ABONADAS_VALIDADAS) {
          let dateToday = new Date();
          let initial = this.operation?.dateStatus?.split(/\//);
          let initialStatus = [initial[1], initial[0], initial[2]].join('/').toString();
          let dateStatus = new Date(initialStatus);
          let ago = new Date(new Date(initialStatus).setMonth(dateStatus.getMonth() + this.requestData?.numPlaz));

          if (dateToday >= ago) {
            const dialogConfig = new MatDialogConfig();
            dialogConfig.data = {
              text: this.translate.instant('policy.privacity.formalized'),
              icon: 'icon-ic_circle_cross',
              buttonCancel: false,
            };
            dialogConfig.disableClose = true;

            this.dialog.open(ResponseDialogComponent, dialogConfig);
          }
        }
        // ESPSCFWMTS-7415 Controlar navegación a detalle de solicitud

        this.isRequestsCallLoaded = true;
      }
    );
  }

  public goToPanel() {
    // //ADMIN go to request search
    // if (this.credentialsService.credentials.userType === UserType.ADMIN) {
    //   this.router.navigate(['/users/search-operation', { keepFilter: true }]);
    // } else {
    this.previousUrl = JSON.parse(localStorage.getItem('previusRoute'));
    this.router.navigate([this.previousUrl.url, { keepFilter: true }]);
    //}
  }

  public changeRequestStatusLoading(value: boolean) {
    this.isRequestsLoaded = value;
    this.triggerStopLoader();
  }

  public changeDocumentationStatusLoading(value: boolean) {
    this.isDocumentationLoaded = value;
    this.triggerStopLoader();
  }

  public isAttrViewTraces(): boolean {
    return this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_VIEW_TRACES);
  }

  isAttrHistoric = (): boolean => {
    return this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_REQUEST_SHOW_EDIT_HISTORIC);
  };

  private triggerStopLoader(): void {
    if (this.isRequestsLoaded && this.isDocumentationLoaded && this.isRequestsCallLoaded) {
      this.loaderGenericService.stopSpinner();
    } else {
      this.loaderGenericService.showSpinner();
    }
  }

  ngOnDestroy() {
    localStorage.removeItem('operationToShow');
  }
}
